import createApiCall from "./endpoints"


export const getPrintCall = token => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'PRINT_GET',
        method: 'GET'
    })
}

export const updatePrintCall = (token, data) => {
    return createApiCall({
        headerParams:   {
            token: token
        },
        baseURL: pmkinoClientVars.siteURL,
        apiEndpoint: 'PRINT_UPDATE',
        method: 'POST',
        data: data
    })
}